// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogVariantEditForm from "./CatalogVariantEditForm.res.js";
import * as CatalogVariantEditFormMutations from "./CatalogVariantEditFormMutations.res.js";

function CatalogVariantEditFormPageActions(props) {
  let productValues = props.productValues;
  let updateVariant = CatalogVariantEditFormMutations.useUpdateVariant();
  let createVariant = CatalogVariantEditFormMutations.useCreateVariant();
  let createProductAndVariant = CatalogVariantEditFormMutations.useCreateProductAndVariant(productValues);
  let onSubmit = props.editionMode ? updateVariant : (
      productValues !== undefined ? createProductAndVariant : createVariant
    );
  return JsxRuntime.jsx(Inline.make, {
    children: JsxRuntime.jsx(CatalogVariantEditForm.SubmitButton.make, {
      label: I18n.t("Save"),
      tone: "success",
      onSubmit: onSubmit
    }),
    space: "small"
  });
}

let make = React.memo(CatalogVariantEditFormPageActions);

let Mutations;

export {
  Mutations,
  make,
}
/* make Not a pure module */
